import { BrowserStorageModel, Module } from 'projects/common/model/ModuleModel';
import { UpaService, UpaTarget } from '../../services/upa.service';
import {Component, Inject, Injector, Input, OnChanges, OnInit, PLATFORM_ID, ViewEncapsulation} from '@angular/core';
import { AbstractComponent } from '../abstract.component';
import {ButtonOptions} from '../eva-button/eva-button.component';
import { Currency } from 'projects/common/model/landingModel';
import { TagTextData } from '../tag-text/tag-text.component';
import { PriceAlertsService } from 'projects/common/services/price-alerts.service';
import { TextBannerModel } from '../text-banner/text-banner.model';
import { isPlatformBrowser } from '@angular/common';
import { PictureData } from '../picture/picture.component';
import { ScreenType } from '@shopping-angular-components/common-library';

@Component({
  selector: 'alerts-banner',
  template: `
    <div class="alerts-banner-wrapper" *ngIf="showBanner && (textBannerModelData?.data?.title || textBannerModelData?.data?.text)">

      <text-banner
        [module]="textBannerModelData"
        (clickEvent)="onButtonClick()">
      </text-banner>

    </div>
  `,
  styleUrls: ['./alerts-banner.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AlertsBannerComponent extends AbstractComponent implements OnInit, OnChanges {
  private static MODULE_ID: string = 'PriceAlertsBannerModule';
  private readonly isBrowser: boolean;

  @Input() override module : Module<AlertBannerModel>;
  @Input() uniqueId?: string;
  @Input() moduleIndex: number;
  @Input() currency: Currency;

  textBannerModelData: Module<TextBannerModel>;
  isMobile: boolean;
  showBanner = true;

  constructor(injector: Injector,
    private priceAlertsService: PriceAlertsService,
   @Inject(PLATFORM_ID) private platformId: object) {

    super(injector);
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    if (!this.isBrowser) return;
    this.isMobile =  this.landingModelService.getLandingModel().device.type === ScreenType.MOBILE;
    
    this.initPriceAlertsData();

    // lo de isFavs puede que no sea necesario, probar si puede caer desde favs
    if (window?.location?.href.indexOf('refererEvent=priceAlert') >= 0  && window?.location?.href.indexOf('isFavsAlerts=true') === -1 && window?.location?.href.indexOf('isFavs=true') === -1){
      if (this.priceAlertsService.existsClickFlagInLocalStorage()){

        this.priceAlertsService.removeClickFlagFromLocalStorage();
        this.priceAlertsService.openAlerts(); 
        this.showBanner = !this.priceAlertsService.alertCalled;
      }
    }
  }

  ngOnChanges(): void {
    if (this.isBrowser && this.module) {
      this.initPriceAlertsData();
    }
  }

  initPriceAlertsData() {
    if (!this.module.data.price_amount) return;
    
    this.textBannerModelData = {
      position: this.module.position,
      row_number: this.moduleIndex,
      id: AlertsBannerComponent.MODULE_ID,
      data: {
        ...this.module.data,
      },
    }
    this.priceAlertsService.setPriceAlertsData(this.module.data);
  }

  getModuleId() {
    return AlertsBannerComponent.MODULE_ID;
  }

  onButtonClick() {
    this.priceAlertsService.saveClickFlagOnLocalStorage();
    this.priceAlertsService.openAlerts();
    this.showBanner = false;
  }
}

export interface AlertBannerModel {
  title: TagTextData;
  text: TagTextData;
  picture?: PictureData;
  button?: ButtonOptions;
  driver?: {text?: string, type?: string};
  browser_storage_condition?: BrowserStorageModel;
  background_color?: string;
  product: string;
  origin_code: string,
  destination_code: string,
  origin_gid: string,
  destination_gid: string,
  flight_type: string,
  destination_city_description: string,
  price_amount: string,
  price_currency_code: string
  formatted_price: string
  border?: boolean;
}
